/* eslint-disable no-console */
/* eslint-disable react/destructuring-assignment */
import React from 'react';
import PropTypes from 'prop-types';
import * as amplitude from '@amplitude/analytics-browser';
import { plugin as engagementPlugin } from '@amplitude/engagement-browser';
import { sessionReplayPlugin } from '@amplitude/plugin-session-replay-browser';
import properties from './properties';
import events from './events';

const AmplitudeContext = React.createContext();
// creates API instance for amplitude
const sessionReplayTracking = sessionReplayPlugin({
  sampleRate: 1
});
amplitude.add(engagementPlugin());
amplitude.add(sessionReplayTracking);
amplitude.init("e1cc15ce421fdc13c7194b57e60ba78e", {
  defaultTracking: true
});

function AmplitudeContextProvider(props) {
  // send an event to amplitude
  function sendEventToAmplitude(event, eventAttributes = {}) {
    amplitude.logEvent(event, eventAttributes);
  }

  function setUserId(id) {
    amplitude.setUserId(id);
  }

  // identify user, sets properties
  function sendToAmplitudeIdentify(key, value) {
    const identify = new amplitude.Identify().setOnce(key, value.email);
    amplitude.identify(identify);
  }

  function updateIdentify(orgName, orgId) {
    const identifyUpdate = new amplitude.Identify()
      .set('organization_name', orgName)
      .set('organization_id', orgId);
    amplitude.identify(identifyUpdate);
    sendEventToAmplitude(events.epic.Organization.switchingOrgs);
  }
  // returns the correct navItem key
  // eslint-disable-next-line consistent-return
  function filterNavItems(key) {
    switch (key) {
      case events.epic.Organization.id:
        return events.epic.Organization.accessOrg;
      case events.epic.PropertiesV2.id:
        return events.epic.PropertiesV2.accessPropertiesV2;
      case events.epic.Properties.id:
        return events.epic.Properties.accessProps;
      case events.epic.CropSeason.id:
        return events.epic.CropSeason.accessCropSeasons;
      case events.epic.Plans.id:
        return events.epic.Plans.accessPlan;
      case events.epic.Recommendations.id:
        return events.epic.Recommendations.accessRecommendations;
      case events.epic.Tasks.id:
        return events.epic.Tasks.accessTasks;
      case events.epic.Invoices.id:
        return events.epic.Invoices.accessInvoice;
      case events.epic.People.id:
        return events.epic.People.accessPeople;
      case events.epic.Companies.id:
        return events.epic.Companies.accessCompanies;
      case events.epic.Equipment.id:
        return events.epic.Equipment.accessEquipment;
      case events.epic.Reports.id:
        return events.epic.Reports.accessReports;
      case events.epic.ProductList.id:
        return events.epic.ProductList.accessPPL;
      case events.epic.ApplicationsAndWorkOrders.id:
        return events.epic.ApplicationsAndWorkOrders.accessApplications;
      case events.epic.ApplicationsAndWorkOrders.workOrdersId:
        return events.epic.ApplicationsAndWorkOrders.accessWorkOrders;
      default:
        return key;
    }
  }

  return (
    <AmplitudeContext.Provider
      value={{
        amplitude,
        events,
        properties,
        setUserId,
        sendEventToAmplitude,
        sendToAmplitudeIdentify,
        filterNavItems,
        updateIdentify
      }}
    >
      {props.children}
    </AmplitudeContext.Provider>
  );
}
AmplitudeContextProvider.propTypes = {
  children: PropTypes.node.isRequired
};

export { AmplitudeContextProvider, AmplitudeContext };
